'use strict';
import {settings} from '../../variables.js'
var angularTemplateBase = settings.angularTemplatesBase
var apiBaseUrl = settings.apiBaseUrl

angular.
module('rent')
.service('CartService', ['ShopCart', function (ShopCart) {
        var shop_cart = ShopCart.get(function(){

        });

        return {
            getCart: function () {
                return shop_cart;
            },
            setCart: function (cart) {
                shop_cart = cart;
            }
        };
}])
.component('renttable', {
        templateUrl: angularTemplateBase+'rent/rent.template.html?3',
        bindings: {
            part: '@'
        },
        controller: ['$routeParams', '$location', '$cookies', 'Part', 'CartService', function RentTableCtrl($routeParams, $location, $cookies, Part, CartService) {
            this.$onInit = function (){
                var self = this;

                self.shop_cart = CartService.getCart();

                self.part_instant = Part.get({objectId: self.part}, function(){

                }, function(){
                    console.log('Error get part')
                });

                self.add_to_cart = function(content_type, object_id, quantity){
                    var item = {
                        cart: self.shop_cart.id,
                        content_type: content_type,
                        object_id: object_id,
                        quantity: quantity
                    }

                    self.shop_cart.items = Array(item);

                    self.shop_cart.$save(
                        function(response, response_status){
                            CartService.setCart(response);
                        },
                        function(response, response_status){

                        }
                    );
                }

            }
        }]
})

.component('addToCart', {
    bindings: {
        contentType: '@',
        objectId: '@',
        quantity: '='
    },
    templateUrl: angularTemplateBase+'rent/add-to-cart.template.html',
    controller: ['$routeParams', '$location', '$cookies', 'CartService', function CartCtrl($routeParams, $location, $cookies, CartService) {
        var self = this
        self.step = "start"
        self.shop_cart = CartService.getCart()

        self.add_to_cart = function(){
            var item = {
                cart: self.shop_cart.id,
                content_type: self.contentType,
                object_id: self.objectId,
                quantity: self.quantity
            }

            self.shop_cart.items = Array(item);

            self.shop_cart.$save(
                function(response, response_status){
                    CartService.setCart(response);
                    self.step = "completed"
                    self.errors = {}
                },
                function(response, response_status){
                    self.step = "start"
                    self.errors = response.data
                }
            );
        }
    }]
})

.component('modalProduct', {
    bindings: {
        productId: '@'
    },
    templateUrl: angularTemplateBase+'rent/modal-product.template.html',
    controller: ['$document', '$uibModal', function ModalProductCtrl($document, $uibModal) {

        var self = this

        self.open_product_modal = function(){

            var parentElem = angular.element($document[0].querySelector('body'));

            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: angularTemplateBase+'rent/product-instance.template.html',
                controller: 'ProductInstanceCtrl',
                controllerAs: '$ctrl',
                size: 'lg',
                appendTo: parentElem,
                resolve: {
                    productId: function() {
                        return self.productId
                    }
                }
            });

        }
        
    }]
})

.component('cart', {
    templateUrl: angularTemplateBase+'rent/cart.template.html',
    controller: ['$routeParams', '$location', '$cookies', 'ShopCart', 'CartService', function CartCtrl($routeParams, $location, $cookies, ShopCart, CartService) {
        var self = this;
        self.shop_cart = CartService.getCart();
    }]
})

.component('cartSidebar', {
    templateUrl: angularTemplateBase+'rent/cart-sidebar.template.html',
    controller: ['$routeParams', '$location', '$cookies', 'ShopCart', 'CartService', function CartCtrl($routeParams, $location, $cookies, ShopCart, CartService) {
        var self = this;
        self.shop_cart = CartService.getCart();
    }]
})

.component('cartFixed', {
    templateUrl: angularTemplateBase+'rent/cart-fixed.template.html',
    controller: ['$routeParams', '$location', '$cookies', 'ShopCart', 'CartService', function CartCtrl($routeParams, $location, $cookies, ShopCart, CartService) {
        var self = this;
        self.shop_cart = CartService.getCart();
    }]
})

.component('profile', {
    templateUrl: angularTemplateBase+'rent/profile.template.html',
    controller: ['$routeParams', '$location', '$cookies', 'User', 'Password', function ProfileCtrl($routeParams, $location, $cookies, User, Password) {
        var self = this;
        self.user = User.get();
        self.password = Password.get();
        self.save_disable = false;
        self.btn_text = 'Сохранить';
        self.btn_password_text = 'Изменить пароль';
        self.save_password_disable = false;

        self.update_user_photo = function(result){
            self.user.photo = result;
        }
        self.setToken = function() {
            return $cookies.get('csrftoken');
        }
        self.save_user = function(){
            self.btn_text = 'Сохранение...';
            self.save_disable = true;
            self.user.$update(function(){
                self.save_disable = false;
                self.btn_text = 'Сохранить';
                self.errors = {};

            }, function(response){
                self.save_disable = false;
                self.errors = response.data;
                self.btn_text = 'Сохранить';
            });
        }

        self.save_password = function(){
            self.btn_password_text = 'Сохранение...';
            self.save_password_disable = true;
            self.password.$update(function(){
                self.btn_password_text = 'Изменить пароль';
                self.save_password_disable = false;
                self.errors = {};
            }, function(response){
                self.btn_password_text = 'Изменить пароль';
                self.save_password_disable = false;
                self.errors = response.data;
            });
        }
    }]
})

.component('orderblank', {
    templateUrl: angularTemplateBase+'rent/orderblank.template.html',
    controller: ['$routeParams', '$location', '$cookies', 'ShopCart', 'CartService', function OrderBlankCtrl($routeParams, $location, $cookies, ShopCart, CartService) {
        var self = this;
        self.shop_cart = CartService.getCart();

        self.add_counts = function(item, count){
            item.quantity = parseInt(item.quantity) + parseInt(count);
            self.shop_cart.$update(function(response, code){CartService.setCart(response);},function(response, code){});
        }
        self.delete_counts = function(item, count){
            item.quantity = parseInt(item.quantity) - parseInt(count);
            if (item.quantity < 1) {
                item.quantity = 1;
            }
            self.shop_cart.$update(function(response, code){CartService.setCart(response);},function(response, code){});
        }

        self.delete_item = function(item) {
            var index_del = -1;
            for (var i = 0; i < self.shop_cart.items.length; i++) {
                if (self.shop_cart.items[i].object_id == item.object_id){
                    index_del = i;
                    continue;
                }
            }
            if (index_del > -1){
                self.shop_cart.items.splice(index_del, 1);
            }
            self.shop_cart.$update(function(response, code){CartService.setCart(response);},function(response, code){});
        }

    }]
})
.component('cartpage', {
    templateUrl: angularTemplateBase+'rent/cartpage.template.html?3',
    controller: ['$routeParams', '$location', '$cookies', 'ShopCart', 'CartService', function OrderBlankCtrl($routeParams, $location, $cookies, ShopCart, CartService) {
        var self = this;
        self.shop_cart = CartService.getCart();

        self.add_counts = function(item, count){
            item.quantity = parseInt(item.quantity) + parseInt(count);
            self.shop_cart.$update(
                function(response, code){
                    CartService.setCart(response);
                    self.errors = {}
                },
                function(response, code){
                    self.errors = response.data
                }
            );
        }
        self.delete_counts = function(item, count){
            item.quantity = parseInt(item.quantity) - parseInt(count);
            if (item.quantity < 1) {
                item.quantity = 1;
            }
            self.shop_cart.$update(
                function(response, code){
                    CartService.setCart(response);
                    self.errors = {}
                },function(response, code){
                    self.errors = response.data
                }
            );
        }

        self.delete_item = function(item) {
            var index_del = -1;
            for (var i = 0; i < self.shop_cart.items.length; i++) {
                if (self.shop_cart.items[i].object_id == item.object_id){
                    index_del = i;
                    continue;
                }
            }
            if (index_del > -1){
                self.shop_cart.items.splice(index_del, 1);
            }
            self.shop_cart.$update(
                function(response, code){
                    CartService.setCart(response);
                    self.errors = {}
                },function(response, code){
                    self.errors = response.data
                }
            );
        }

        self.add_day_to_cart = function(){
            self.shop_cart.days_count = self.shop_cart.days_count + 1;
            self.shop_cart.$update(
                function(response, code){
                    CartService.setCart(response);
                    self.errors = {}
                },function(response, code){
                    self.errors = response.data
                }
            );
        }

        self.delete_day_from_cart = function(){
            var new_count = self.shop_cart.days_count - 1;
            if (new_count > 0){
                self.shop_cart.days_count = new_count;
                self.shop_cart.$update(
                    function(response, code){
                        CartService.setCart(response);
                        self.errors = {}
                    },function(response, code){
                        self.errors = response.data
                    }
                );
            }
        }

    }]
})
.component('orderform', {
    templateUrl: angularTemplateBase+'rent/orderform.template.html?4',
    controller: ['$routeParams', '$location', '$cookies', 'ShopCart', 'CartService', 'Order', 'DeliveryList', function OrderFormCtrl($routeParams, $location, $cookies, ShopCart, CartService, Order, DeliveryList) {
        var self = this;

        self.step = 'start';
        self.registerForm = false;

        self.order = Order.get({});

        self.delivery_list = DeliveryList.query();

        self.save_order = function(){
            self.order.$save(
                function(response, response_status){
                    self.order = response;
                    self.shop_cart = CartService.getCart();
                    CartService.setCart(self.shop_cart);
                    self.step = 'complete';

                },
                function(response, response_status){
                    self.errors = response.data;
                }
            );
        }
    }]
})
.component('orderslist', {
    templateUrl: angularTemplateBase+'rent/orderslist.template.html',
    controller: ['$routeParams', '$location', '$cookies', 'OrdersList', 'ProductsList', function OrdersListFormCtrl($routeParams, $location, $cookies, OrdersList, ProductsList) {
        var self = this;

        self.orders = OrdersList.query({}, function(){

        },
        function(){
            console.log('Error get orders list');
        });

        self.get_items = function(order){
            order.items = ProductsList.query({cart_id: order.cart});
        }


    }]
})

.component('invoices', {
    templateUrl: angularTemplateBase+'rent/invoices.template.html?2',
    controller: ['$routeParams', '$location', '$cookies', '$uibModal', '$document', 'Invoices', function OrdersListFormCtrl($routeParams, $location, $cookies, $uibModal, $document, Invoices) {
        var self = this;
        self.invoices = Invoices.query({}, function(){

        },
        function(){
            console.log('Error get Invoices list');
        });

        self.open_payment_modal = function(invoice_id, summary, parentSelector){


            var parentElem = parentSelector ? angular.element($document[0].querySelector('body')) : undefined;
            console.log(parentElem);

            var modalInstance = $uibModal.open({
                animation: this.animationsEnabled,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: angularTemplateBase+'rent/payment-modal.template.html?3',
                controller: 'PaymentInstanceCtrl',
                controllerAs: '$ctrl',
                appendTo: parentElem,
                resolve: {
                    invoice_id: invoice_id,
                    summary: summary
                }
            });

        }

    }]
})
.controller('PaymentInstanceCtrl', function ($uibModalInstance, invoice_id, summary) {
    var self = this;
    self.invoice_id = invoice_id;
    self.summary = summary;
    self.step = 'start';

    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    self.set_step = function(step){
        self.step = step;
    }

})

.controller('ProductInstanceCtrl', ['$uibModalInstance', 'productId', 'Product', '$sce', function ProductInstanceCtrl($uibModalInstance, productId, Product, $sce) {
    var self = this;

    self.apiBaseUrl = apiBaseUrl

    self.productId = productId

    self.product = Product.get({objectId: self.productId});

    self.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    self.safeHtml = function (source) {
        return $sce.trustAsHtml(source)
    }

}])
;